module.exports = __webpack_public_path__ + "img/player_turn_006.e162ecb2.png";